import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import global from '../../../common/utility/global';
import Header from '../../../components/Header';
import Filters from './Filters';
import GeneralTable from './GeneralTable';

import productoService from '../../../service/administracion/productoService';
import reporteVencimientoService from '../../../service/logistica/reporteVencimientoService';
export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        // this.props.onSetBreadcrumb();
        this.state = {
            monedas: [],
            productos: [],
            estados: [{ id: 1, nombre: 'SOLO VENCIDOS' }, { id: 2, nombre: 'SOLO POR VENCER' }],
            productosAutocomplete: [],
            almacenesLoading: false,
            productosLoading: false,
            loadingExcel: false,
            monedasLoading: false,
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                lote: "",
                idProducto: 0,
                referencia: '',
                estado: 0,
            },
            DataSource: [],
            pagination: PAGINATION,
        }
    }


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter };
            this.setState({ filter });

        }
    };

    handleChange = async (property, value) => {

        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };


    handleSearchAutocomplete = (value) => {
        try {
            const result = this.state.productos.filter(item => {
                return (item.nombre).toUpperCase().match(value.toUpperCase());
            }).slice(0, 75);
            this.setState({ productosAutocomplete: result });
        } catch (error) {
            console.log(error);
        }
    };

    handleChangeAutocomplete = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: value.key
            }
        });
    };

    handleClearAutocomplete = () => {
        this.setState({
            filter: {
                ...this.state.filter,
                idProducto: 0
            }
        });
    }

    handleClearFilters = () => {
        var filter = {
            idProducto: 0,
            estado: 0,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            lote: "",
            referencia: ''
        };
        this.setState({
            filter,
            DataSource: []
        });
    };

    handleSearch = async () => {

        var dataSource = [];
        dataSource = await reporteVencimientoService.general(this.state.filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: true,
            showResumen: false,
            showDetallado: false
        });

    }

    handleExportExcelGeneral = async () => {
        this.setState({ loadingExcel: true });
        var response = await reporteVencimientoService.excelGeneral(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte Stock General.xlsx");
    }







    _handleChangePagination = async (pagination) => {
        var dataSource = [];
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter });
        dataSource = await reporteVencimientoService.general(filter);
        this.setState({
            pagination: dataSource ? dataSource : [],
            showGeneral: true,
            showResumen: false,
            showDetallado: false
        });
    };
    async componentDidMount() {

        const productos = await productoService.listar();
        const productos_filter = productos.filter(m => m.idTipoProducto === 1);
        const dataSource = await reporteVencimientoService.general(this.state.filter);

        this.setState({
            productos: productos_filter ? productos_filter : [],
            establecimientosLoading: false,
            DataSource: dataSource.data,
            pagination: dataSource
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Reporte Productos por Vencer"
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    productos={this.state.productosAutocomplete}
                    estados={this.state.estados}
                    productosLoading={this.state.productosLoading}
                    almacenesLoading={this.state.almacenesLoading}
                    onSearchAutocomplete={this.handleSearchAutocomplete}
                    onChangeAutocomplete={this.handleChangeAutocomplete}
                    onClearAutocomplete={this.handleClearAutocomplete}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <GeneralTable
                    dataSource={this.state.DataSource}
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    onExportExcel={this.handleExportExcelGeneral}
                    onChange={this._handleChangePagination}
                />
            </div>
        );
    }
}